import { componentsRegistryService, RxBucket } from "cruzo";
import { ModalComponent, ModalConfig } from "cruzo/ui-components/modal";

export const appScope = new RxBucket(
  {
    profileModal: {
      config: ModalConfig({
        bodyContent: `<profile-component></profile-component>`,
        dependencies: new Set([
          "profile-component",
          "plus-icon",
          "button-group-component",
          "input-component",
          "spinner-component",
        ]),
      }),
    },
    subscriptionManageModal: {
      config: ModalConfig({
        bodyContent: `<subscription-manage-component></subscription-manage-component>`,
        dependencies: new Set(["subscription-manage-component"]),
      }),
    },
    proofreadPromptModal: {
      config: ModalConfig({
        bodyContent: `<proofread-prompt-modal-component></proofread-prompt-modal-component>`,
        dependencies: new Set(["proofread-prompt-modal-component"]),
      }),
    },
    editorLockModal: {
      config: ModalConfig({
        bodyContent: `<editor-lock-modal-component></editor-lock-modal-component>`,
        dependencies: new Set(["editor-lock-modal-component"]),
      }),
    },
    zeptoRowSwapModal: {
      config: ModalConfig({
        bodyContent: `<zepto-row-swap-modal-component></zepto-row-swap-modal-component>`,
        dependencies: new Set(["zepto-row-swap-modal-component"]),
      }),
    },
    createRuleModal: {
      config: ModalConfig({
        bodyContent: `<create-rule-modal-component></create-rule-modal-component>`,
        dependencies: new Set(["create-rule-modal-component"]),
      }),
    },
    createBookModal: {
      config: ModalConfig({
        bodyContent: `<create-book-modal-component></create-book-modal-component>`,
        dependencies: new Set(["create-book-modal-component", "input-component"]),
      }),
    },
    ownerPaymentCancelModal: {
      config: ModalConfig({
        bodyContent: `<owner-payment-cancel-modal-component></owner-payment-cancel-modal-component>`,
        dependencies: new Set(["owner-payment-cancel-modal-component", "spinner-component"]),
      }),
    },
    ownerPaymentReceiptModal: {
      config: ModalConfig({
        bodyContent: `<owner-payment-receipt-modal-component></owner-payment-receipt-modal-component>`,
        dependencies: new Set(["owner-payment-receipt-modal-component"]),
      }),
    },
    exerciseImageModal: {
      config: ModalConfig({
        bodyContent: `<exercise-image-modal-component></exercise-image-modal-component>`,
        dependencies: new Set(["exercise-image-modal-component"]),
      }),
    },
    imageGalleryModal: {
      config: ModalConfig({
        bodyContent: `<image-gallery-modal-component></image-gallery-modal-component>`,
        dependencies: new Set(["image-gallery-modal-component", "input-component"]),
      }),
    },
    suggestNewWordsModal: {
      config: ModalConfig({
        bodyContent: `<suggest-new-words-modal-component></suggest-new-words-modal-component>`,
        dependencies: new Set(["suggest-new-words-modal-component"]),
      }),
    },
    lessonRulesModal: {
      config: ModalConfig({
        bodyContent: `<lesson-rules-modal-component></lesson-rules-modal-component>`,
        dependencies: new Set(["lesson-rules-modal-component"]),
      }),
    },
    lessonWordsModal: {
      config: ModalConfig({
        bodyContent: `<lesson-words-modal-component></lesson-words-modal-component>`,
        dependencies: new Set(["lesson-words-modal-component"]),
      }),
    },
    editorLessonRulesModal: {
      config: ModalConfig({
        bodyContent: `<editor-lesson-rules-modal-component></editor-lesson-rules-modal-component>`,
        dependencies: new Set(["editor-lesson-rules-modal-component"]),
      }),
    },
    lessonTranslateModal: {
      config: ModalConfig({
        bodyContent: `<lesson-translate-modal-component></lesson-translate-modal-component>`,
        dependencies: new Set(["lesson-translate-modal-component"]),
      }),
    },
  }
);

componentsRegistryService.connectBucket(appScope);
